import store, { RootState } from "@invesco/shared/store/index";
import { sha256 } from "@noble/hashes/sha2.js";
import { bytesToHex, utf8ToBytes } from "@noble/hashes/utils.js";
import crashlytics from "@react-native-firebase/crashlytics";
import Constants from "expo-constants";
import { Platform } from "react-native";

const isNative = Platform.OS === "android" || Platform.OS === "ios";

let originalHandler: any = undefined;

async function initCrashlytics() {
  if (!isNative) return;
  try {
    const pan = (store?.getState?.() as RootState)?.user?.pan;
    const appVersion = Constants?.expoConfig?.version || "-";
    const platform = Platform.OS;
    // Hash PAN for privacy (same as analytics.ts - truncated to 25 chars)
    const userID = pan ? bytesToHex(sha256(utf8ToBytes(pan))).slice(0, 25) : "-";

    await crashlytics().setCrashlyticsCollectionEnabled(true);
    // Set user and app context early
    try {
      if (userID && userID !== "-") await crashlytics().setUserId(String(userID));
      await crashlytics().setAttributes({
        user_id_hash: userID,
        platform,
        app_version: appVersion,
      });
    } catch (e) {
      console.error("[Crashlytics] Error setting attributes", e);
    }
    if (typeof (global as any).ErrorUtils?.getGlobalHandler === "function") {
      originalHandler = (global as any).ErrorUtils.getGlobalHandler();
    }
    if (typeof (global as any).ErrorUtils?.setGlobalHandler === "function") {
      (global as any).ErrorUtils.setGlobalHandler((error: any, isFatal?: boolean) => {
        try {
          // Log message and stack BEFORE recordError — Crashlytics attaches
          // preceding logs to the crash report, not subsequent ones.
          const msg = String(error?.message || error || "Unknown JS error");
          const stack = String(error?.stack || "").slice(0, 1024);
          crashlytics().log(`[JS Exception] fatal=${!!isFatal} | ${msg}`);
          if (stack) crashlytics().log(`[Stack] ${stack}`);
          crashlytics().setAttributes({
            user_id_hash: userID,
            last_js_exception: String(error?.message || error) || msg.slice(0, 200),
            last_js_exception_fatal: String(!!isFatal),
          });
          crashlytics().recordError(error);
        } catch (e) {
          console.error("[Crashlytics] Error recording exception", e);
        }
        if (originalHandler) {
          try {
            originalHandler(error, isFatal);
          } catch (e) {
            console.error("[Crashlytics] original handler failed", e);
          }
        }
      });
    }
  } catch (e) {
    console.warn("[Crashlytics] init failed", e);
  }
}

export default initCrashlytics;
